import { createDeferredLoadable } from '../../utils/createDeferredLoadable';
export const LoadablePublicCreditsExplainer = createDeferredLoadable(() => import( /* webpackChunkName: "public-credits-explainer" */'./PublicCreditsExplainer').then(m => ({
  default: m.default
})));